import { useState, useEffect } from 'react';
import { useTranslation } from '@/contexts/TranslationContext';

export const useTranslatedText = (originalText: string) => {
  const { translateText, currentLanguage } = useTranslation();
  const [translatedText, setTranslatedText] = useState(originalText);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const doTranslation = async () => {
      if (!originalText) {
        setTranslatedText(originalText);
        return;
      }

      setLoading(true);
      try {
        const result = await translateText(originalText);
        setTranslatedText(result);
      } catch (error) {
        console.error('Translation error:', error);
        setTranslatedText(originalText);
      } finally {
        setLoading(false);
      }
    };

    doTranslation();
  }, [originalText, currentLanguage, translateText]);

  return { translatedText, loading };
};